module.exports = __webpack_public_path__ + "static/media/icon-edit.e999106a.svg";